import { useBrandInfo } from '~/hooks/useBrandInfo';

export default function Main({ children }: { children: React.ReactNode }) {
  const { isDreamscape } = useBrandInfo();

  const style: React.CSSProperties = {
    maxWidth: isDreamscape ? undefined : '1280px',
    minHeight: '60vh',
    backgroundColor: 'inherit',
  };

  // Set padding to undefined only when Dreamscape brand
  if (isDreamscape) {
    style.padding = undefined;
  }

  return (
    <section className="main" style={style}>
      {children}
    </section>
  );
}
